"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var BuildOutline = {
  name: 'build',
  theme: 'outline',
  nameWithTheme: 'build-o',
  tag: 'svg',
  attrs: {
    xmlns: 'http://www.w3.org/2000/svg',
    class: 'icon',
    viewBox: '0 0 1024 1024'
  },
  children: [{
    tag: 'path',
    attrs: {
      d: 'M916 210H376c-17.7 0-32 14.3-32 32v236H108c-17.7 0-32 14.3-32 32v272c0 17.7 14.3 32 32 32h540c17.7 0 32-14.3 32-32V546h236c17.7 0 32-14.3 32-32V242c0-17.7-14.3-32-32-32zm-504 68h200v200H412V278zm-68 468H144V546h200v200zm268 0H412V546h200v200zm268-268H680V278h200v200z'
    },
    children: []
  }]
};
exports.default = BuildOutline;